import { render, staticRenderFns } from "./AudioDetail.vue?vue&type=template&id=73540e3a&scoped=true"
import script from "./AudioDetail.vue?vue&type=script&lang=js"
export * from "./AudioDetail.vue?vue&type=script&lang=js"
import style0 from "./AudioDetail.vue?vue&type=style&index=0&id=73540e3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73540e3a",
  null
  
)

export default component.exports